<template>
  <div class="okta-login-wrapper" :class="{ spinner: loading }">
    <NsSpinner v-show="loading" />
    <article class="okta-login" v-show="!loading" data-app>
      <section></section>
      <div class="login">
        <h2 class="page-title">{{ txc.pageTitle }}</h2>
        <div class="subtitle">{{ txc.welcomeText }}</div>
      </div>
      <div v-if="!showWebDirect">
        <div id="okta-signin-container"></div>

        <div id="customError" v-if="showCustomError">
          <section class="customError">
            <p>{{ txe.accountDisabled }}</p>
          </section>
        </div>

        <div id="signupMarketing" v-if="!hideSignup">
          <section class="line">
            <h4 class="center">
              {{ txc.signUpMarketingTitle }}
            </h4>
          </section>
          <section
            class="signup-button"
            :class="{ mb: !showGuestCheckout }"
            v-if="!showCustomerSignup"
          >
            <button
              class="secondary-hit fluid login-button"
              @click="handleSignUp"
            >
              {{ txc.signUpBtnText }}
            </button>
          </section>
          <section class="signup-button adr" v-if="showCustomerSignup">
            <button
              class="secondary-hit fluid login-button"
              @click="handleADRSignUp"
            >
              {{ txc.signUpBtnText }}
            </button>
          </section>
          <section class="or-separator" v-if="showGuestCheckout">
            <span class="or-text">{{ txc.orSeparator || "OR" }}</span>
          </section>
          <section class="guest-checkout-wrapper" v-if="showGuestCheckout">
            <button
              class="secondary-hit fluid guest-checkout-button"
              @click="handleGuestCheckout"
            >
              {{ txc.continueAsGuestBtnText || "Continue to Guest Checkout" }}
            </button>
          </section>
          <div style="margin-top: -10px" v-if="!showGuestCheckout">
            <!-- eslint-disable vue/no-v-html -->
            <p class="center" v-html="txc.signUpMarketingTagline"></p>
            <!-- eslint-enable vue/no-v-html -->
            <ul class="benefits">
              <li v-for="(benefits, index) in marketingBenefits" :key="index">
                {{ benefits.text }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <web-account-direct :language="language" v-if="showWebDirect" />
    </article>
  </div>
</template>

<script>
import OktaSignIn from "@okta/okta-signin-widget";
import "@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";
import { AuthenticationService, UserService } from "@nuskin/ns-account";
import { events } from "@nuskin/ns-util";
import sampleConfig from "../config";
import md5 from "md5";
import WebAccountDirect from "../components/WebAccountDirect";
import NsSpinner from "../components/NsSpinner";
import { OktaAuth } from "@okta/okta-auth-js";
import profileUtils from "../utils/profileUtils";
import { UsesFeatureFlags } from "@nuskin/ns-feature-flags-vue";
import { axios } from "@nuskin/axios-util";
import gtm from "@nuskin/ns-gtm";

export default {
  name: "Login",
  components: {
    NsSpinner,
    WebAccountDirect,
  },
  mixins: [UsesFeatureFlags],
  data() {
    return {
      loading: false,
      txc: window.loginTranslations,
      txe: window.loginPageErrorMsg,
      showWebDirect: false,
      showCustomError: false,
      eidRequired: false,
      isVerified: false,
      label_signin: "サインイン",
      label_forgotpassword: "パスワードをお忘れの方/アカウントがロックされた方",
      label_username_placeholder: "ログインID",
      label_password_placeholder: "パスワード",
      label_forgot_email_or_username_placeholder:
        "パスワードを忘れた場合や、パスワードを何度も間違えて入力した場合等、パスワードの再設定が 必要となります。下記にログイン ID を入力し「送信」ボタンを押すと登録したアドレス宛にメールが 送信されますので、同メールより再設定を行ってください。また、メールは「no-reply@nuskin.com」 より送信されますので、受信できるよう設定しておいてください。 ログイン ID を忘れた場合は、ご本人より下記までお問い合わせください。お問い合わせ】メンバー専用窓口（（フリーダイヤル：0120-200-449（固定電話専用）、TEL：03-4540-7121、受付：平日 9:00～17:30",
      label_forgot_email_or_username_tooltip: "ログインIDを入力",
      label_password_forgot_sendEmail: "送信",
      label_password_forgot_emailSent_desc:
        "ご確認の上手続きを行ってください。メールが届かない場合、入力したログインIDが間違っている、または、迷惑メールに分類されている可能性がありますので、確認をお願いいたします。",
      label_password_forgot_emailSent_desc1:
        "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u30EA\u30BB\u30C3\u30C8\u306B\u3064\u3044\u3066\u3001{0}\u5B9B\u3066\u306BE\u30E1\u30FC\u30EB\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002",
      label_email_button_send: "サインイン",
      en_label_forgot_email_or_username_placeholder:
        "Due to a site security upgrade, you may experience a problem logging in. Please try resetting your password.",
      showGuestCheckout: false,
    };
  },
  props: {
    destinationUrl: {
      type: String,
      default: window.redirectUrl,
    },
    hideSignup: {
      type: Boolean,
      default: window.loginPageConfig.hideSignup,
    },
    language: {
      type: String,
      default: "en",
    },
    errorCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isCartPage() {
      const url = new URL(window.location.href);
      const destination = url.searchParams.get("destination");
      return !!destination && destination.includes("cart.html");
    },
    isMysite() {
      const url = new URL(window.location.href);
      const destination = url.searchParams.get("destination");
      return !!destination && destination.includes("mysite");
    },
    isADR() {
      const cartData = JSON.parse(localStorage.getItem("shop-cart"));
      return cartData?.products?.some((product) => product.adr);
    },
    showCustomerSignup() {
      const isGuest = JSON.parse(localStorage.getItem("nuskin.account.data"));
      return isGuest?.user?.isGuest && this.isADR;
    },

    marketingBenefits: function () {
      let benefits = [];
      benefits.push({
        text: this.txc.signUpMarketingBenefits1,
      });
      benefits.push({
        text: this.txc.signUpMarketingBenefits2,
      });
      benefits.push({
        text: this.txc.signUpMarketingBenefits3,
      });
      benefits.push({
        text: this.txc.signUpMarketingBenefits4,
      });
      return benefits;
    },
    locale() {
      const urlParams = new URLSearchParams(window.location.search);
      let locale = "en_US"; // default locale
      if (urlParams.has("destination")) {
        const destination = urlParams.get("destination");
        const match = destination.match(/\/([a-z]{2}_[A-Z]{2})\//);
        if (match && match[1]) {
          locale = match[1];
        }
      }
      return locale;
    },
    country() {
      return this.locale.split("_")[1];
    },
    warmSignupURL() {
      return `${sampleConfig.signupBaseUrl}/${this.locale}/guest-checkout/?sponsor=${this.sponsorStorage}`;
    },
    guestSignupURL() {
      return `${sampleConfig.signupBaseUrl}/${this.locale}/guest-checkout/?sponsor=NSHOUSE&inviteId=coldGuestSignup`;
    },
    ADRSignupURL() {
      return `${sampleConfig.signupBaseUrl}/${this.locale}/CUSTOMER/signup-page/?origin=WBC&sponsor=RETFLOAT`;
    },
    sponsorStorage() {
      return sessionStorage.getItem("sponsor");
    },
  },

  mounted: function () {
    const self = this;
    if (
      window.location.href.includes("mynuskin.com/content/login/corporate/") &&
      gtm &&
      gtm.datalayer
    ) {
      gtm.datalayer.push = function () {
        return null;
      };
    }
    this.checkTokens();

    this.checkMaps();
    if (
      typeof window.loginPageConfig.language != "undefined" &&
      window.loginPageConfig.language
    ) {
      self.language = window.loginPageConfig.language;
      switch (self.language) {
        case "nl":
          self.language = "nl-NL";
          break;
        case "zh":
          self.language = "zh-TW";
          break;
        case "zh_CN":
          self.language = "zh-CN";
          break;
        case "zh_TW":
          self.language = "zh-TW";
          break;
        case "pt":
          self.language = "pt-BR";
          break;
      }
    }
    if (typeof window.passEid != "undefined" && window.passEid.length > 0) {
      this.eidRequired = true;
    }

    this.$nextTick(function () {
      this.widget = new OktaSignIn({
        baseUrl: sampleConfig.oidc.baseUrl,
        clientId: sampleConfig.oidc.clientId,
        redirectUri: sampleConfig.oidc.redirectUri,
        language: self.language,
        i18n: {
          ja: {
            signin: this.label_signin,
            forgotpassword: this.label_forgotpassword,
            "primaryauth.username.placeholder": this.label_username_placeholder,
            "primaryauth.password.placeholder": this.label_password_placeholder,
            "password.forgot.email.or.username.placeholder":
              this.label_forgot_email_or_username_placeholder,
            "password.forgot.email.or.username.tooltip":
              this.label_forgot_email_or_username_tooltip,
            "password.forgot.sendEmail": this.label_password_forgot_sendEmail,
            "password.forgot.emailSent.desc":
              this.label_password_forgot_emailSent_desc1 +
              " " +
              this.label_password_forgot_emailSent_desc,
            "email.button.send": this.label_email_button_send,
          },
          en: {
            "password.forgot.email.or.username.placeholder":
              this.en_label_forgot_email_or_username_placeholder,
          },
        },
        features: {
          rememberMe: false,
          showPasswordToggleOnSignInPage: true,
        },
        authParams: {
          pkce: true,
          issuer: sampleConfig.oidc.issuer,
          display: "page",
          scopes: sampleConfig.oidc.scopes,
          responseType: ["id_token", "token"],
          maxClockSkew: 7200,
        },
      });

      this.widget.renderEl(
        { el: "#okta-signin-container" },
        (res) => {
          this.handleLogin(res);
        },
        (err) => {
          throw err;
        }
      );
      this.widget.on("afterError", (context, error) => {
        let username = "";
        let requestId = "";
        try {
          if (typeof window.newrelic != "undefined") {
            username = window.document.getElementById(
              "okta-signin-username"
            ).value;
            requestId = md5(username.toLowerCase());
            error.requestId = requestId;
            window.newrelic.addPageAction("oktaLoginWidgetError", error);
            window.newrelic.addPageAction("oktaLoginWidgetContext", context);
          }
        } catch (e) {
          console.log("afterError");
        }
        self.errorCount++;
        // if (self.errorCount == 1) {
        //   // this.showWebDirect = true;
        //   AuthenticationService.isUsernameAvailable(
        //     username,
        //     (err, response) => {
        //       if (response.data.available) {
        //         AuthenticationService.isUsernameAvailableInGigyaRef(
        //           username,
        //           function (errorResponse) {
        //             if (errorResponse === null) {
        //               try {
        //                 window.newrelic.addPageAction(
        //                   "oktaLoginNoAccount",
        //                   error
        //                 );
        //               } catch (ex) {
        //                 console.log("_");
        //               }
        //               self.showWebDirect = true;
        //             }
        //           }
        //         );
        //       }
        //     }
        //   );
        // }
        if (self.errorCount > 4) {
          let username = "";
          let requestIdValue = "";
          try {
            if (typeof window.newrelic != "undefined") {
              username = window.document.getElementById(
                "okta-signin-username"
              ).value;
              requestIdValue = md5(username.toLowerCase());
            }
          } catch (e) {
            console.log("afterError");
          }
          setTimeout(function () {
            let backLink = document.getElementsByClassName("js-back")[0];
            backLink.addEventListener("click", function () {
              self.hideSignup = false;
              window.newrelic.addPageAction("oktaLoginWidgetSkippedReset", {
                requestId: requestIdValue,
              });
            });
            let emailButtonClick =
              document.getElementsByClassName("email-button")[0];
            emailButtonClick.addEventListener("click", function () {
              self.hideSignup = false;
              window.newrelic.addPageAction("oktaLoginWidgetResetPerformed", {
                requestId: requestIdValue,
              });
            });
          }, 500);
          this.hideSignup = true;
          let hashLoc = window.location.href.search("#/signin/forgot-password");
          if (hashLoc !== -1)
            window.location = window.location.href.substring(0, hashLoc);
          else
            window.location = window.location.href + "#/signin/forgot-password";
        }
      });
    });

    // Subscribe to gigya login events
    events.subscribe(
      events.authentication.ERROR_TOO_MANY_LOGIN_ATTEMPTS,
      () => {
        this.processing = false;
        this.valid = true;
        this.loginDisabled = true;
        this.captchaNeeded = true;
      }
    );
    events.subscribe(events.authentication.INVALID_LOGIN_ATTEMPT, () => {
      this.processing = false;
      this.valid = true;
      this.loginerror = true;
      this.isUsingGigyaAuthentication = false;
    });
    events.subscribe(events.authentication.LOGIN_MAX_ATTEMPTS, () => {
      this.processing = false;
      this.valid = false;
      this.loginerror = true;
    });
    events.subscribe(events.authentication.LOGIN_LOCKED, () => {
      this.processing = false;
      this.valid = false;
      this.loginerror = true;
    });
    events.subscribe(events.authentication.RESET_PASSWORD_ERROR, () => {
      this.processing = false;
      this.valid = false;
      this.loginerror = true;
    });

    events.subscribe(events.authentication.LOGIN_COMPLETE, () => {
      this.processing = false;
      this.valid = true;
      this._completeLogin();
    });
    events.subscribe(events.authentication.PNP_CHECK, () => {
      //await this._callJitMigrationEndPoint();
    });
  },
  methods: {
    doSomething(error) {
      console.log(error);
    },
    handleSignUp() {
      events.publish(events.authentication.REQUEST_FOR_SIGNUP, ["From login"]);
    },
    handleADRSignUp() {
      window.location = this.ADRSignupURL;
    },
    handleGuestCheckout() {
      if (this.isMysite) {
        window.location = this.warmSignupURL;
      } else {
        window.location = this.guestSignupURL;
      }

      if (this.showGuestCheckout) {
        gtm.dataLayer.push({
          event: "guest_checkout",
          type: "guest_checkout",
          platform: "legacy",
        });
      }
    },
    checkTokens() {
      this.loading = true;
      const authClient = new OktaAuth(sampleConfig.oidc);
      authClient.session.exists().then((exists) => {
        if (exists) {
          // logged in
          authClient.token
            .getWithoutPrompt({
              responseType: "id_token", // or array of types
              sessionToken: "testSessionToken", // optional if the user has an existing Okta session
            })
            .then(async (res) => {
              let tokens = res.tokens;
              authClient.tokenManager.setTokens(tokens);
              const userInfo = await authClient.token.getUserInfo();
              const username = userInfo.preferred_username;
              const data = {
                accessToken: tokens.accessToken.accessToken,
                idToken: tokens.idToken.idToken,
              };
              sessionStorage.setItem("oktaTokens", JSON.stringify(data));
              let result = await AuthenticationService.oktaLogin(
                data,
                username
              );
              if (result === "User is deleted") {
                this.showCustomError = true;
                this.loading = false;
              }
            })
            .catch((err) => {
              // handle OAuthError or AuthSdkError (AuthSdkError will be thrown if app is in OAuthCallback state)
              this.loading = false;
              console.log(err);
            });
        } else {
          // not logged in
          this.loading = false;
          console.log("user not logged in");
          return;
        }
      });
    },
    async handleLogin(res) {
      const data = {
        accessToken: res.tokens.accessToken.value,
        idToken: res.tokens.idToken.value,
      };
      let username = "";
      try {
        username = window.document.getElementById("okta-signin-username").value;
        if (typeof window.newrelic != "undefined") {
          let requestId = md5(username.toLowerCase());
          window.newrelic.addPageAction("oktaLoginWidgetSuccess", requestId);
        }
      } catch (e) {
        console.log("_");
      }

      if (this.featureEnabled("cx13-15592-enable-email-verify-feature")) {
        this.isVerified = await profileUtils.isEmailVerified(username);
      }
      let result = await AuthenticationService.oktaLogin(data, username);
      if (result === "User is deleted") {
        this.showCustomError = true;
      }
      sessionStorage.setItem("oktaTokens", JSON.stringify(data)); //check out line 332
    },

    setTranslations() {
      let txc = window.loginTranslations;

      this.signUpMarketingTagline = txc.signUpMarketingTagline;
    },
    checkMaps() {
      axios
        .put(
          `${sampleConfig.apiBaseUrl}/contentstack-configuration/v1/maps`,
          {
            market: this.country,
            configMaps: ["Signup"],
          },
          {
            headers: {
              accept: "application/json, text/plain, */*",
              "accept-language": "en-US,en;q=0.9",
              client_id: "8a397ee8e55a4398b4aaa881323d7398",
              "content-type": "application/json",
            },
          }
        )
        .then((response) => {
          this.showGuestCheckout =
            response.data.Signup.enableGuestCheckout &&
            this.isCartPage &&
            !this.isADR;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    _completeLogin() {
      this.loginerror = false;
      if (
        typeof this.destinationUrl != "undefined" &&
        this.destinationUrl.length > 0
      ) {
        this.destinationUrl = this._decodeUrl(this.destinationUrl);
      } else {
        this.destinationUrl = document.referrer;
      }

      let skipVerifyRedirect =
        new URLSearchParams(window.location.search)
          .get("skipVerifyRedirect")
          ?.toLowerCase() === "true";
      if (
        !skipVerifyRedirect &&
        this.featureEnabled("cx13-15592-enable-email-verify-feature") &&
        !this.isVerified
      ) {
        this.destinationUrl = profileUtils.getRedirectUrl();
      }
      // If and eid is needed, add query params to end of dest url from user service
      if (this.eidRequired) {
        const eid = UserService.getUser().eid;
        window.location =
          this.destinationUrl +
          "?accountId=" +
          UserService.getUser().id +
          "&eid=" +
          eid;
      } else {
        window.location = this.destinationUrl;
      }
    },
    _decodeUrl(_urlParam) {
      return _urlParam.replace("_hb_", "#");
    },
  },
  destroyed() {
    // Remove the widget from the DOM on path change
    this.widget.remove();
  },
};
</script>

<style lang="scss">
.okta-login-wrapper {
  &.spinner {
    display: flex;
    width: 100%;
    justify-content: center;
  }
}
.okta-login {
  #okta-sign-in {
    &.auth-container {
      margin-top: 10px !important;
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }
    .auth-header {
      border: none !important;
    }
    .auth-content {
      border: none !important;
      vertical-align: unset;
      padding: 20px;
      .okta-form-label {
        font-weight: 400;
      }
      .help-links {
        li {
          margin-top: 0;
        }
      }
    }
    .o-form-button-bar {
      padding: 0;
      &.focused-input {
        margin: 0;
      }
    }
    .o-form {
      label {
        font-size: 16px;
      }
      .input-fix {
        height: 40px;
      }
    }
  }

  section {
    width: 100%;
    &:not(.signup-button) {
      padding: 20px 40px 20px;
    }
    &.mb {
      margin-bottom: 30px;
    }
    padding: 0 40px 0;
  }

  input[type="text"],
  input[type="password"] {
    //   height: 45px !important;
    min-height: unset;
    max-height: unset;
  }

  .page-title {
    text-transform: uppercase;
    font-size: 40px;
    font-weight: 100;
    margin-bottom: 10px;
  }

  #help-links-container {
    display: block !important;
  }
  .okta-form-title.o-form-head,
  .link.help.js-help,
  .link.help.js-help.o-form-disabled,
  .okta-sign-in-header,
  .link.js-help-link {
    display: none !important;
  }
  .o-form-label,
  .okta-form-input-error,
  li {
    text-align: left;
  }
  .js-forgot-password {
    bottom: 90px;
    position: relative;
    // font-size: 14px !important;
    display: block;
  }
  #okta-sign-in .button-primary,
  .link-button {
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#252525),
      to(#252525)
    ) !important;
    background-color: #252525 !important;
    border-color: #252525 !important;
    color: #fff;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 18px;
    letter-spacing: 1.07px;
    text-decoration: none !important;
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    cursor: pointer;
    outline: 0 !important;
    padding: 13px 20px;
    position: relative;
    text-align: center;
  }

  //   .link-button {
  //     height: 40px !important;
  //     line-height: 38px !important;
  //   }

  button.secondary-hit {
    background: none;
    // font-family: map.get(typographyVariables.$typography, "font-family-primary");
    //   font-weight: map.get(typographyVariables.$typography, "font-weight-semibold");
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 1.07px;
    text-decoration: none !important;
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    cursor: pointer;
    outline: 0 !important;
    padding: 13px 20px;
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row wrap;
    border-color: #252525;
    color: #252525;
    // width: 350px;
    margin-bottom: 20px;
    &:hover {
      background-color: rgba(45, 45, 45, 0.05);
      border-color: #252525;
      color: #252525;
    }
    &:active {
      background-color: rgba(45, 45, 45, 0.05);
      color: #252525;
    }
    &:disabled,
    &:disabled:hover {
      border-color: #bbbcdc;
      color: #bbbcdc;
      background-color: transparent;
    }
  }

  .okta-form-input-field,
  .o-form-input-name-username {
    outline: none;
    font-weight: 300;
    border-color: #bbbcbc;
    color: #252525;
    border: 1px solid #63666a;
    width: 100%;
    transition: border 0.15s ease-in-out;
    background-color: #fff;
    height: 30px;
    padding: 16px 15px;
    font-size: 16px;
    line-height: 22px;
    box-shadow: none;
    border-radius: 0;
    max-height: 30px;
    min-height: 30px;
    @media screen and (max-width: 767px) {
      max-height: 45px;
      height: 45px;
      min-height: 30px;
    }

    &.focused-input {
      border-color: #94d6e9 !important;
      box-shadow: none;
    }
  }

  div#signupMarketing {
    display: flex;
    width: 100%;
    padding: 10px 0;
    max-width: 500px;
    justify-content: center;
    flex-flow: column wrap;
    align-items: center;
    border-top: 1px solid;
    margin: 0 auto;
  }

  #okta-sign-in .o-form label {
    font-size: 16px;
  }

  h4 {
    font-size: 18px;
    font-weight: 300;
  }
  .benefits {
    padding-top: 20px;
    li {
      font-size: 16px;
      padding-bottom: 7px;
      line-height: 21px;
    }
  }
  #customError {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 300;
    color: #c81d1d;
    background: #f4d8d8;
    border-style: solid;
    border-width: thin;
    border-color: #c81d1d;
  }
  /* OR separator styling */
  .or-separator {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 40px;
  }

  .or-text {
    text-transform: uppercase;
    font-size: 14px;
    color: #666;
    margin: 0 10px;
  }

  .or-separator:before,
  .or-separator:after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: #ccc;
  }
}
</style>
